import styles from "../styles/Button.module.css";
import { Link } from "react-router-dom";

export default function Button({
  children,
  href,
  variant = "btnBase",
  size = "btnAuto",
}) {
  return (
    <Link
      to={href}
      className={`${styles.btn} ${styles[variant]} ${styles[size]}`}
    >
      {children} <span className={styles.chev}>›</span>
    </Link>
  );
}
